import BillingNotice from "@/components/billing-notice";
import type { ReactNode } from "react";

import { LocaleSync } from "@/components/locale-provider";
import { usePage } from "@inertiajs/react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useFlash } from "@/hooks/use-flash";
import { RouteAccessibility } from "@/components/route-accessibility";

interface PersistentLayoutProps {
  children: ReactNode;
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash();
  const access = usePage().props.billing_access;
  return (
    <LocaleSync>
      <TooltipProvider>
        <RouteAccessibility />
        {children}
        {access?.show_notice && <BillingNotice reason={access.reason} />}
        <Toaster richColors />
      </TooltipProvider>
    </LocaleSync>
  );
}
